import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";

export function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="bg-slate-950 text-slate-200 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 sm:py-24">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-primary mb-4">Let's Talk Solar</p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl">
          Cut your EB bill. Power your future with the sun.
        </h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-slate-800 pt-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo.jpg" alt="Jehovah Nissi Solar Agency logo" className="w-9 h-9 rounded-md object-cover" />
              <span className="font-heading font-semibold text-white">Jehovah Nissi Solar Agency</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Trusted solar products and installation partner for homes, farms and businesses across Trichy.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-400 mb-4">Visit Us</p>
            <p data-testid="footer-address" className="text-sm leading-relaxed flex gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
              <span>New No 15/1, Khajapetta,<br />Thiruchappali, Tamil Nadu 620001</span>
            </p>
            <p data-testid="footer-phone" className="text-sm leading-relaxed flex gap-2 mt-4">
              <Phone className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
              <a href="tel:+916374135100" className="hover:text-primary transition-colors duration-200">+91 63741 35100</a>
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-400 mb-4">Quick Links</p>
            <div className="flex flex-col gap-2 text-sm">
              <a href="/#shop" data-testid="footer-shop-link" className="hover:text-primary transition-colors duration-200 w-fit">Shop Products</a>
              <a href="/#why-solar" data-testid="footer-why-link" className="hover:text-primary transition-colors duration-200 w-fit">Why Solar</a>
              <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-primary transition-colors duration-200 w-fit">Admin Login</Link>
            </div>
          </div>
        </div>
        <p className="mt-12 text-xs text-slate-500">&copy; {new Date().getFullYear()} Jehovah Nissi Solar Agency. All rights reserved.</p>
      </div>
    </footer>
  );
}
